import { create } from "zustand";
import { persist } from "zustand/middleware";
import { fetchAvailability, fetchAvailabilityExceptions } from "../services/AvailbilityService";
import { toWeeklyAvailabilityDays } from "../utils/availabilitySchedule";

const useAvailabilityStore = create(
    persist(
        (set) => ({
            availability: [],
            exceptions: [],
            setAvailability: (availability) => set({ availability }),
            setExceptions: (exceptions) => set({ exceptions }),
            clearAvailability: () => set({ availability: [] }),
            clearExceptions: () => set({ exceptions: [] }),
            fetchCurrentWeekAvailability: async (userId) => {
                if (!userId) {
                    return [];
                }

                const today = new Date();
                const day = today.getDay();
                const start = new Date(today);
                start.setDate(today.getDate() - day);
                start.setHours(0, 0, 0, 0);

                const end = new Date(start);
                end.setDate(start.getDate() + 6);
                end.setHours(23, 59, 59, 999);

                const payload = await fetchAvailability(
                    start.toISOString().slice(0, 10),
                    end.toISOString().slice(0, 10),
                    60
                );

                const availabilityPayload = payload?.availability;
                const weeklyData = Array.isArray(availabilityPayload)
                    ? availabilityPayload
                    : availabilityPayload?.days ?? [];
                const nextAvailability = toWeeklyAvailabilityDays(weeklyData);
                set({ availability: nextAvailability });
                return nextAvailability;
            },
            fetchAvailabilityExceptions: async (userId) => {
                if (!userId) {
                    return [];
                }

                const payload = await fetchAvailabilityExceptions(userId);
                const nextExceptions = payload?.exceptions ?? [];
                set({ exceptions: nextExceptions });
                return nextExceptions;
            },
        }),
        {
            name: "availability-storage",
            version: 2,
            migrate: (persistedState) => ({
                ...persistedState,
                availability: toWeeklyAvailabilityDays(persistedState?.availability ?? []),
            }),
        }
    )
);

export default useAvailabilityStore;